import { NavLink } from "react-router-dom";

const linkStyle = ({ isActive }) => ({
  color: isActive ? "#ffe600" : "rgba(200,200,255,0.7)",
  textDecoration: "none",
  fontFamily: "Impact, Arial Black, sans-serif",
  fontStyle: "italic",
  fontSize: "14px",
  letterSpacing: "2px",
  textTransform: "uppercase",
  padding: "6px 10px",
  borderBottom: isActive ? "2px solid #ff2d78" : "2px solid transparent",
});

export default function Header() {
  return (
    <header style={{ background: "#08000f", borderBottom: "1px solid rgba(0,245,255,0.25)", padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
      <NavLink to="/" style={{ textDecoration: "none" }}>
        <span style={{ fontFamily: "Impact, Arial Black, sans-serif", fontStyle: "italic", fontSize: "20px", letterSpacing: "2px", background: "linear-gradient(135deg, #ff2d78, #ffe600, #00f5ff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", textTransform: "uppercase" }}>
          Comedy Toolkit
        </span>
      </NavLink>
      <nav style={{ display: "flex", gap: "4px" }}>
        <NavLink to="/puns" style={linkStyle}>Puns</NavLink>
        <NavLink to="/limericks" style={linkStyle}>Limericks</NavLink>
      </nav>
    </header>
  );
}
